import { useState } from "react";
import {
  formatCurrency,
  formatPercentageView,
} from "../../../../../../utils/formatViews";
import { Button, Container, FormGrid, InputWrapper } from "../../styles";
import LoadingOverlay from "../../../../../../components/LoadingOverlay";
import { T2 } from "../../../../../../styles/titles";
import { Row } from "antd";
import { Label } from "../../../../styles";
import { AnticipationFeeData, IFilter } from "../../types";
import AnticipationFeeService from "../../service/AnticipationFeeService";

const InsertFee: React.FC<IFilter> = (props: IFilter) => {
  const { getFilters } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [adValorem, setAdValorem] = useState("");
  const [dailyIof, setDailyIof] = useState("");
  const [additionalIof, setAdditionalIof] = useState("");
  const [operationFee, setOperationFee] = useState("");
  const anticipationFeeService = new AnticipationFeeService();

  const handleOperationFee = (e: any) => {
    let rawValue = e.target.value.replace(/\D/g, "");

    const formattedValue = formatCurrency(rawValue);
    setOperationFee(formattedValue);
  };

  const handleAdValoremFee = (e: any) => {
    const rawValue = e.target.value.replace(/\D/g, "");

    const formattedValue = formatPercentageView(rawValue);
    setAdValorem(formattedValue);
  };

  const handleDailyIof = (e: any) => {
    const rawValue = e.target.value.replace(/\D/g, "");

    const formattedValue = formatPercentageView(rawValue);
    setDailyIof(formattedValue);
  };

  const handleAdditionalIof = (e: any) => {
    const rawValue = e.target.value.replace(/\D/g, "");

    const formattedValue = formatPercentageView(rawValue);
    setAdditionalIof(formattedValue);
  };

  const handleSaveChanges = async () => {
    setIsLoading(true);

    try {
      const newAnticipationFee: AnticipationFeeData = {
        adValorem: parseFloat(adValorem) || 0,
        dailyIof: parseFloat(dailyIof) || 0,
        additionalIof: parseFloat(additionalIof) || 0,
        operationFee: parseFloat(operationFee.replace(",", ".")) || 0,
      };

      await anticipationFeeService.postInsertAnticipationFees(
        newAnticipationFee
      );
      getFilters(newAnticipationFee);
    } catch (error) {
      console.log("Erro ao salvar as taxas: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container style={{ padding: "0px" }}>
      <Row style={{ marginBottom: 8 }}>
        <Label>Cadastrar Taxas:</Label>
      </Row>
      <FormGrid>
        <InputWrapper>
          <input
            type="text"
            placeholder="AdValorem"
            value={adValorem}
            onChange={handleAdValoremFee}
          />
          {adValorem && <span className="suffix">%</span>}
        </InputWrapper>

        <InputWrapper>
          <input
            type="text"
            placeholder="IOF Diário"
            value={dailyIof}
            onChange={handleDailyIof}
          />
          {dailyIof && <span className="suffix">%</span>}
        </InputWrapper>

        <InputWrapper>
          <input
            type="text"
            placeholder="IOF Adicional"
            value={additionalIof}
            onChange={handleAdditionalIof}
          />
          {additionalIof && <span className="suffix">%</span>}
        </InputWrapper>

        <InputWrapper className="currency">
          <span className="prefix">R$</span>
          <input
            type="text"
            placeholder="Valor da Operação"
            value={operationFee}
            onChange={handleOperationFee}
          />
        </InputWrapper>
        <Button onClick={handleSaveChanges}>Salvar</Button>
      </FormGrid>
    </Container>
  );
};

export default InsertFee;
